/* HerbalKart bundle & quantity selector (audit ref H4) - 29 Jul 2026
   Progressive enhancement only. Without this file the quantity input is a
   plain number field and the form still submits correctly; the tier cards
   simply stop driving it.

   Deliberately does not touch cart logic: selecting a tier sets the value of
   the theme's own `quantity` input, so Add to Cart, the dynamic Buy Now
   button and the ajax drawer keep the behaviour the theme already defines.

   Revert: delete this file, assets/hk-bundle.css,
   snippets/hk-bundle-selector.liquid, and their tags in
   snippets/css-variables.liquid. */
(function () {
  'use strict';

  /* Format cents using the theme's own currency helper when it is available,
     so output always matches the rest of the page. Falls back to the money
     format string exposed in layout/theme.liquid. */
  function money(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  /* Highest-qualifying tier for a quantity. Tiers are thresholds, matching
     how a Shopify automatic discount with a minimum-quantity requirement
     behaves, so quantities above a tier keep that tier's rate. */
  function rateFor(tiers, qty) {
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].qty && tiers[i].pct > pct) pct = tiers[i].pct;
    }
    return pct;
  }

  function init(root) {
    if (root.hkBundleReady) return;
    root.hkBundleReady = true;

    var form = root.closest('form[action*="/cart/add"]');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    var radios = [].slice.call(root.querySelectorAll('[data-hk-tier]'));
    var totalEl = root.querySelector('[data-hk-summary-total]');
    var saveEl = root.querySelector('[data-hk-summary-save]');

    var unitPrice = parseInt(root.getAttribute('data-unit-price'), 10) || 0;
    var tiers = [];
    try {
      tiers = JSON.parse(root.getAttribute('data-tiers')) || [];
    } catch (e) {
      tiers = [];
    }

    /* Recalculate the running total from the current quantity. */
    function render() {
      var qty = parseInt(qtyInput.value, 10);
      if (!qty || qty < 1) qty = 1;

      var pct = rateFor(tiers, qty);
      var full = unitPrice * qty;
      var total = Math.round((full * (100 - pct)) / 100);
      var saved = full - total;

      if (totalEl) totalEl.textContent = money(total);

      if (saveEl) {
        if (saved > 0) {
          saveEl.textContent = 'You save ' + money(saved) + ' (' + pct + '%)';
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }

      /* Keep the tier cards in step with the stepper: check the highest tier
         the quantity satisfies, or clear them all for an off-tier quantity. */
      var bestIndex = -1;
      var bestQty = 0;
      radios.forEach(function (r, i) {
        var rq = parseInt(r.getAttribute('data-qty'), 10) || 1;
        if (qty >= rq && rq >= bestQty) {
          bestQty = rq;
          bestIndex = i;
        }
      });
      radios.forEach(function (r, i) {
        r.checked = i === bestIndex && qty === bestQty;
      });
    }

    /* Tier click sets the quantity, then lets the shared render run. */
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        qtyInput.value = r.getAttribute('data-qty') || '1';
        // Notify the theme's own quantity handlers.
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        render();
      });
    });

    /* Typed input. */
    qtyInput.addEventListener('input', render);

    /* On commit, normalise an invalid quantity so the form can never submit
       0 or a non-number. The theme's own QtySelector validates to 1 as well,
       so both paths converge on the same value. */
    qtyInput.addEventListener('change', function () {
      var q = parseInt(qtyInput.value, 10);
      if (!q || q < 1) qtyInput.value = '1';
      render();
    });

    /* Impulse's QtySelector.changeQty() sets the input with jQuery's .val()
       and triggers only a namespaced event on <body> - it fires neither
       `input` nor `change` on the field, so the +/- buttons are invisible to
       the listeners above. Re-reading on the next tick after a click on the
       wrapper picks up the new value regardless of which handler ran first,
       without depending on the theme's internal event namespace. */
    var qtyWrapper = root.querySelector('.js-qty__wrapper');
    if (qtyWrapper) {
      qtyWrapper.addEventListener('click', function (evt) {
        if (!evt.target.closest('.js-qty__adjust')) return;
        setTimeout(render, 0);
      });
    }

    /* Multi-variant safety: Impulse triggers a jQuery `variantChange` event
       carrying the new variant. Single-variant products never fire it. */
    if (window.jQuery) {
      var container = root.closest('[data-section-id]') || form;
      window.jQuery(container).on('variantChange', function (evt) {
        if (evt && evt.variant && typeof evt.variant.price === 'number') {
          unitPrice = evt.variant.price;
          render();
        }
      });
    }

    render();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-hk-bundle]')).forEach(init);
  }

  /* This file is loaded with `defer` from the document head, ahead of
     theme.js. A deferred script executes while readyState is "interactive",
     so booting on anything other than DOMContentLoaded would run before
     theme.js has defined theme.Currency and prices would render unformatted.
     boot() is idempotent, so the extra load listener is a harmless backstop
     for the case where this file is ever loaded async or late. */
  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
